import styled from 'styled-components';

import {colors, border, font} from '../../theme';

export const RadioGroup = styled.div`
    display: flex;
    gap: 16px;
`;

export const RadioItem = styled.label`
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0;
    border-radius: 8px;
    transition: background-color 0.2s;
`;

export const RadioInput = styled.input.attrs({type: 'radio'})`
    opacity: 0;
    position: absolute;
    width: 0;
    height: 0;
`;

export const RadioCustom = styled.span<{type: 'default' | 'small'; disabled?: boolean}>`
    box-sizing: border-box;
    width: ${(p) => (p.type === 'default' ? '20px' : '10px')};
    height: ${(p) => (p.type === 'default' ? '20px' : '10px')};
    border: ${(p) => (p.type === 'default' ? '2px' : '1px')} solid #ccc;
    border-radius: 50%;
    margin-right: 12px;
    position: relative;
    flex-shrink: 0;
    transition: border-color 0.2s;

    ${RadioInput}:checked + & {
        border: ${(p) => (p.type === 'default' ? '6px' : '1px')} solid #007bff;
        border-color: ${colors.brandPrimary};
    }
    ${RadioInput}:disabled + & {
        border-color: grey;
    }
`;

export const RadioContent = styled.div`
    display: flex;
`;

export const RadioLabel = styled.span`
    font-weight: 600;
    color: #333;
`;

export const RadioDescription = styled.span`
    font-size: 14px;
    color: #666;
`;
